import { useAuth } from '@shared/auth';
import { Skeleton } from '@shared/components';

import { useSidebar } from '../../../providers';
import MenuItem, { type MenuItemProps } from '../menu-item';

import UserAvatarIcon from './user-avatar-icon';

type UserMenuItemProps = Partial<MenuItemProps>;

function UserMenuItem(props: Readonly<UserMenuItemProps>) {
  const { user } = useSidebar();
  const { profileLoading: isProfileLoading } = useAuth();

  return (
    <MenuItem
      {...props}
      label={
        isProfileLoading ? (
          <Skeleton variant='text' sx={{ width: '100%', height: '100%' }} />
        ) : (
          (user.displayName.trim() ?? 'Guest User')
        )
      }
      icon={<UserAvatarIcon />}
    />
  );
}

export default UserMenuItem;
